const Reload = function ReloadCurrentPage() {
	/*
        Just reloads the current page.
    */

	window.location.reload(false);
};

export default Reload;
